import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  @Input() appTitle: string;
  @Input() subTitulo: string;
  private _divider: boolean = false;
  get divider(): boolean {
    return this._divider;
  }
  @Input() set divider(v: string | boolean) {
    if (typeof v === 'boolean') {
      this._divider = v;
      return;
    }

    this._divider = v !== undefined;
  }
  @Input() paddingBottom = true;
}
